import { defineMessages } from '@transcend-io/internationalization';

export const dataSubjectRequestFormMessages = defineMessages(
  'pc-core-components.DataSubjectRequestForm.dataSubjectRequestForm',
  {
    submit: {
      defaultMessage: 'Confirm Request',
      description:
        'Text for the DSR submit button after final confirmation form.',
    },
    buttonTitle: {
      defaultMessage:
        'Please confirm the above items before submitting the request',
    },
    shortForm: {
      defaultMessage: 'Short PI Report',
      description: 'Title for Short PI/Categories Only Access Request Option.',
    },
    shortFormDescription: {
      defaultMessage: 'We will tell you the categories of data we hold on you.',
      description:
        'Description for Short PI/Categories Only Access Request Option',
    },
    region: {
      defaultMessage: 'Country/State of Residency',
    },
    expandedForm: {
      defaultMessage: 'Expanded PI Report',
      description: 'Title for Expanded PI/Full Access Request Option',
    },
    expandedFormDescription: {
      defaultMessage: 'We will give you a copy of the data we hold on you.',
      description: 'Description for Expanded PI/Full Access Request Option',
    },
    subDivision: {
      defaultMessage: 'Country Subdivision (optional)',
    },
  },
);
